<template>
    <v-dialog
      v-model="dialog"
      transition="dialog-bottom-transition"
      persistent
      fullscreen>
      <div class="new-order-section">

        <div class="row-new-order">

            <img
              :src="require('@/assets/imgs/svgs/commercia-logo.svg')"
              style="width: 200px;">

            <v-text-field
              style="max-width: 300px;"
              type="text"
              placeholder="Buscar"
              v-model="currentSearch"
              color="#222222"
              clearable
              @click:clear="clearSearch"
              variant="underlined">
              <template v-slot:append-inner>
                <v-icon color="#222222" icon="mdi-magnify" size="small"/>
              </template>
            </v-text-field>

            <v-btn
              color="#FF5700"
              variant="text"
              @click="dialog = false">
              <v-icon left>mdi-chevron-left</v-icon>
              Regresar
            </v-btn>
        </div>

        <div class="row-new-order" style="height: 100%;">

          <div class="section-categories">
            <div
              v-for="category in categories" :key="category._id"
              :class="categorySelected === category._id
              ? 'category-element-selected' : 'category-element'"
              @click="categorySelected= category._id"
              style="cursor: pointer;">
              <span class="name-category">{{ category.name }}</span>
              <span class="cont-category">{{ category.products }} productos</span>
            </div>
          </div>

          <div class="section-products">
            <div v-for="product in products" :key="product._id"
              class="data-product-element"
              style="cursor: pointer;"
              @click="addProductToCard(product)">

              <div class="container-up">
                <img class="img-product-element"
                  :src="product.img ? product.img : require('@/assets/imgs/png/product_default.png')"/>
                <span>{{ product.name }}</span>
              </div>

              <div class="container-down">
                <span>{{formatMoney( product.price )}}</span>
                <v-btn icon color="#FF5700" size="25" rounded="sm">
                  <v-icon size="20">mdi-plus</v-icon>
                </v-btn>
              </div>

            </div>
          </div>

          <div class="section-order">
            <div class="container-shopping-cart">

              <div class="header-shopping-cart">
                <span>Detalles de la orden</span>
                <span>Total: ${{ getTotal() }}</span>
              </div>

              <div class="list-shopping-cart">
                <div v-for="(item) in shopingCart" :key="item._id"
                  class="element-shopping-cart">

                  <div class="element-shopping-cart-line">
                    <span>#{{ item.sku }}</span>
                    <span>${{ item.pay_total }} </span>
                  </div>

                  <div class="element-shopping-cart-line">
                    <span style="font-weight: bold;">{{ item.name }}</span>
                  </div>

                  <div style="margin-top: 10px;"></div>
                  <span v-for="extra in item.extras_select" :key="extra._id">
                      + {{extra.name}}
                  </span>

                  <span style="margin-top: 10px;">
                      {{item.note}}
                  </span>

                  <div class="element-shopping-cart-line">

                    <v-btn variant="text"
                      rounded="sm"
                      @click="openExtras(item)">
                      <v-icon color="red">
                        mdi-plus
                      </v-icon>
                      <span class="txt-btn-order">
                        Personalizar
                      </span>
                    </v-btn>
                    <v-btn variant="text"
                      rounded="sm"
                      @click="deleteProduct(item)">
                      <v-icon color="red">
                        mdi-delete-forever-outline
                      </v-icon>
                      <span class="txt-btn-order">Eliminar </span>
                    </v-btn>

                    <div class="container-quantity">
                      <v-btn icon color="#E7E7E7" size="25" rounded="sm"
                        @click="restProduct(item)">
                        <v-icon size="20">mdi-minus</v-icon>
                      </v-btn>
                      <div class="lbl-quantity">{{ item.quantity }}</div>
                      <v-btn icon color="#FF5700" size="25" rounded="sm"
                        @click="addProduct(item)">
                        <v-icon size="20">mdi-plus</v-icon>
                      </v-btn>
                    </div>

                  </div>

                </div>
              </div>

              <div class="btns-shopping-cart">

                <v-btn
                  style="width: 100%;
                    height: 50px;
                    margin-bottom: 0px !important;"
                  color="#FF5700"
                  :disabled="disabledBtnCreate()"
                  :loading="isLoadOrder"
                  @click="createOrder()">
                  Cobrar ${{getTotal()}}
                </v-btn>
              </div>

            </div>
          </div>
        </div>
      </div>

      <new-orede-extra ref="extraModal" />

      <new-order-pay ref="payModal" @closePay="orderCreateSucces"/>

    </v-dialog>
</template>

<script>
import categoriesApi from '@/api/categoriesApi'
import catalogApi from '@/api/catalogApi'
import moneyTransform from '@/utils/moneyTransform'
import NewOredeExtra from '@/components/forms/NewOrderExtras.vue'
import NewOrderPay from '@/components/forms/NewOrderPay.vue'
export default {
  name: 'CommerciaVueNewOrder',
  emits: ['refreshList'],
  components: {
    NewOredeExtra,
    NewOrderPay
  },
  data () {
    return {
      dialog: false,
      currentSearch: '',
      user: this.$store.getters.user,
      categories: [],
      categorySelected: 'Favorites',
      products: [],
      payOption: '',
      shopingCart: [],
      isLoadOrder: false
    }
  },
  created () {
    this.getCategories()
    this.getProducts()
  },
  watch: {
    categorySelected (newVal, oldVal) {
      this.getProducts()
    },
    currentSearch (newVal, oldVal) {
      this.getProducts()
    }
  },
  methods: {
    open () {
      this.dialog = true
      this.categorySelected = 'Favorites'
    },
    clearSearch () {
      this.currentSearch = ''
      this.getProducts()
    },
    addProductToCard (product) {
      const existingProduct = this.shopingCart.find(
        p => p._id === product._id &&
        p.extras_select.length === 0)
      if (existingProduct) {
        existingProduct.quantity += 1
        existingProduct.pay_total =
          product.price * existingProduct.quantity
      } else {
        this.shopingCart.push({
          ...product,
          quantity: 1,
          extras_select: [],
          pay_total: product.price
        })
      }
    },

    async getCategories () {
      this.categories = await categoriesApi.listForOrder(this.user.terminal)
    },

    async getProducts () {
      if (this.categorySelected === 'Favorites') {
        this.products = await catalogApi.listByFavorites(this.user.terminal, this.currentSearch)
      } else {
        this.products = await catalogApi.listByCategory(this.categorySelected, this.currentSearch)
      }
    },

    formatMoney (intValue) {
      return moneyTransform.intToMoney(intValue)
    },

    getTotal () {
      let total = 0
      for (const item of this.shopingCart) {
        total += item.pay_total
        for (const extra of item.extras_select) {
          total += extra.price
        }
      }
      return total
    },
    addProduct (product) {
      product.quantity += 1
      product.pay_total = product.price * product.quantity
    },
    restProduct (product) {
      product.quantity -= 1
      if (product.quantity <= 0) {
        this.shopingCart = this.shopingCart.filter(p => p !== product)
      } else {
        product.pay_total = product.price * product.quantity
      }
    },
    deleteProduct (product) {
      this.shopingCart = this.shopingCart.filter(p => p !== product)
    },
    disabledBtnCreate () {
      return !(this.getTotal() > 0 && !this.isLoadOrder)
    },
    createOrder () {
      this.$refs.payModal.open(this.shopingCart)
    },
    openExtras (item) {
      this.$refs.extraModal.open(item)
    },
    orderCreateSucces () {
      this.dialog = false
      this.$emit('refreshList')
    }

  }
}
</script>

<style scoped>
@import '@/assets/styles/order.css';
@import '@/assets/styles/inputs.css';
</style>
